import { render, staticRenderFns } from "./LaborManagementMonthly.vue?vue&type=template&id=71387850&scoped=true&"
import script from "./LaborManagementMonthly.vue?vue&type=script&lang=ts&"
export * from "./LaborManagementMonthly.vue?vue&type=script&lang=ts&"
import style0 from "./LaborManagementMonthly.vue?vue&type=style&index=0&id=71387850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71387850",
  null
  
)

export default component.exports